import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import PreviewWrapper from '@/components/checkup/PreviewWrapper.vue'
import { setLocalTrackElement } from '@/helpers/device.helper'
import { useDeviceStore } from '@/stores'
import { onMounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewVideo',
  setup(__props) {

const localTrackRef = ref<HTMLVideoElement>()
const device = useDeviceStore()
const setLocalTrack = () => {
  const option = {
    haveAudio: device.haveAudio,
    haveVideo: device.haveVideo,
    cameraOn: device.cameraOn,
    microphoneOn: device.microphoneOn,
  }
  setLocalTrackElement(
    {
      localTrackRef: localTrackRef.value,
      localTracks: device.localTracks,
      option,
    },
    (level) => {
      device.audioLevel = level
    },
  )
}
watch(
  () => device.localTracks,
  () => setLocalTrack(),
  { deep: true },
)
onMounted(() => {
  setLocalTrack()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PreviewWrapper, {
    "is-ready": _unref(device).isReady,
    "camera-enabled": _unref(device).cameraOn,
    "is-camera-found": _unref(device).haveVideo,
    "allowed-camera": _unref(device).allowedCamera,
    "microphone-enabled": _unref(device).microphoneOn,
    "is-microphone-found": _unref(device).haveAudio,
    "allowed-microphone": _unref(device).allowedMicrophone,
    onToggleCamera: _unref(device).toggleCamera,
    onToggleMicrophone: _unref(device).toggleMicrophone
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "localTrackRef",
        ref: localTrackRef,
        class: "video-track --me"
      }, null, 512)
    ]),
    _: 1
  }, 8, ["is-ready", "camera-enabled", "is-camera-found", "allowed-camera", "microphone-enabled", "is-microphone-found", "allowed-microphone", "onToggleCamera", "onToggleMicrophone"]))
}
}

})